/* eslint-disable */

import {bus} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'add-subscription',
  components: {},
  props: ['email'],
  data() {
    return {
      subscription_period: 12,
      remark: '',
      submitted: false,

    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {
    getUserListAgain() {
      this.$store.dispatch('getUserListDetailsOfDashboard').then((res) => {
        bus.$emit('HideAddSubscriptionPopup', false);
      }).catch((err) => {})
    },
    validateCreateSubscriptionBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let expiration_date = new Date();
          expiration_date.setMonth(expiration_date.getMonth() + this.subscription_period);
          let data = {
            email: this.email,
            expiration_date: expiration_date,
            remark: this.remark
          }
          this.$store.dispatch('createSubscription', data).then((res) => {
            if (res.status == '200' || res.status == '201') {
              toast.success(res.data.msg);
              this.getUserListAgain()
              this.$validator.reset();
            }
          }).catch((err) => {})
          return;
        }
      });
    },
    PopupClose() {
      bus.$emit('HideAddSubscriptionPopup', false);
    },
  }
}